/* eslint-disable indent */
/* eslint-disable import/no-unresolved */
import React from 'react';
import styled from 'styled-components';

import { Container } from '@nfs-react/components';

import { useText, useImg } from 'hooks';
import { MOBILE, TABLET, DESKTOP } from 'helpers/styles/media';
import { ChangeableBackgroundSection } from 'helpers/components';

const Bonus = () => {
  return (
    <ChangeableBackgroundSection
      id="bonus-wrapper-bg"
      defaultStyle={{ backgroundColor: 'transparent' }}
    >
      <Container>
        <BonusWrapper>
          <BonusImage>{useImg('bonus-label.svg')}</BonusImage>
          <BonusText>{useText('bonus__text', true)}</BonusText>
        </BonusWrapper>
      </Container>
    </ChangeableBackgroundSection>
  );
};

const BonusWrapper = styled.div`
  position: absolute;
  top: 40px;
  display: flex;
  flex-direction: column;
  align-items: center;
  z-index: 101;

  @media ${DESKTOP} {
    flex-direction: row;
    top: 510px;
  }

  @media ${TABLET} {
    flex-direction: row-reverse;
    top: 450px;
  }
`;

const BonusText = styled.div`
  color: #D50707;
  text-align: right;
  font-size: 45px;
  font-weight: 700;
  line-height: normal;
  max-width: 166px;

  @media ${DESKTOP} {
    font-size: 55px;
    max-width: 205px;
  }

  @media ${MOBILE} {
    text-align: left;
  }
`;
const BonusImage = styled.div`
  img {
    width: 100%;
  }

  @media ${DESKTOP} {
    width: 250px;
  }

  @media ${TABLET} {
    width: 206px;
  }

  @media ${MOBILE} {
    width: 157px;
  }
`;

export default Bonus;
